import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "1920",
  height: "377",
  viewBox: "0 0 1920 377",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M0 376.532C0 376.532 321 347.016 953.5 364.508C1586 382 1920 356.532 1920 356.532V0.5H0V376.532Z" }, null, -1)
  ])))
}
export default { render: render }